import React, { useEffect, useRef, useState } from 'react';
import { Modal } from 'react-bootstrap';
import { SupplierVS } from 'shared/utils/validation/AuthValidation';
import styles from './style.module.scss';
import classNames from 'classnames';
import Heading from 'shared/components/common/heading/Heading';
import CustomInput from 'shared/components/common/custom_input/CustomInput';
import CustomButton from 'shared/components/common/custom_button/CustomButton';
import { useSelector } from 'react-redux';
import { useFormik } from 'formik';
import { GetAllPOQuery } from 'shared/services/po_service/POService';
import Select from 'react-select';
import { wareHouse } from 'shared/utils/Enum';
import WareHouse from '../add_warehouse/WareHouse';
import { GetAllWarehouse } from 'shared/services/ware_house_service/WareHouseService';


export default function PurchaseOrderSuplierModal({ show, handleClose, SubmmitPo, setSupplierVal, isEdit = false }) {
    const {
        theme: { theme }
    } = useSelector((state) => state.root);

    const { isLoading, data: PoList, isError, error } = GetAllPOQuery();

    const [supplierSuggestions, setSupplierSuggestions] = useState([]);
    const [wareHouses, setWareHouses] = useState([]);

    const [showSuggestions, setShowSuggestions] = useState(false);
    const [showWareModal, setshowWareModal] = useState(false);
    const { data: listWareHouse } = GetAllWarehouse();

    const closeProductHandler = () => {

        setshowWareModal(false);
    }

    const suggestionRef = useRef(null);

    const initialValues = {
        supplier: '',
        address: '',
        phone: '',
        refFeild: '',
        whareHouse: ''
    };
    console.log(wareHouses, "wareHouses");

    const formik = useFormik({
        enableReinitialize: true,
        initialValues: initialValues,
        validationSchema: SupplierVS,
        onSubmit: (value) => {
            const payload = {
                supplier: {
                    name: value.supplier,
                    address: value.address,
                    phone: value.phone
                },
                others: {
                    refFeild: value.refFeild,
                    warehouse: value.whareHouse?.value || '',

                }
            };

            SubmmitPo(payload);
        }
    });

    const { handleSubmit, values, touched, errors, setFieldValue } = formik;

    // Handle input change and show filtered supplier suggestions
    const handleSupplierChange = (e) => {
        const inputValue = e.target.value;
        setFieldValue('supplier', inputValue);

        if (PoList && PoList.length > 0 && inputValue.trim() !== '') {
            // Filter suppliers matching input
            const matchedSuppliers = PoList
                .filter(po => po.supplier?.name?.toLowerCase().includes(inputValue.toLowerCase()))
                .map(po => ({
                    name: po.supplier?.name,
                    address: po.supplier?.address,
                    phone: po.supplier?.phone
                }));

            // Remove duplicates by name
            const uniqueSuppliers = matchedSuppliers.filter(
                (obj, index, self) =>
                    index === self.findIndex((o) => o.name === obj.name)
            );

            setSupplierSuggestions(uniqueSuppliers);
            setShowSuggestions(true);
        } else {
            setSupplierSuggestions([]);
            setShowSuggestions(false);
        }
    };

    // On suggestion click, fill supplier field and close suggestions
    const handleSelectSuggestion = (supplier) => {
        setFieldValue('supplier', supplier.name);
        setFieldValue('address', supplier.address || '');
        setFieldValue('phone', supplier.phone || '');
        setShowSuggestions(false);
    };

    // Close suggestions if clicked outside input + suggestion box
    useEffect(() => {
        const options = (listWareHouse || []).map((w) => ({
            ...w,
            label: w?.code,
            value: w?._id,
        }));

        setWareHouses(options);
        function handleClickOutside(event) {
            if (suggestionRef.current && !suggestionRef.current.contains(event.target)) {
                setShowSuggestions(false);
            }
        }
        document.addEventListener('mousedown', handleClickOutside);
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };

    }, [listWareHouse]);

    const customAddBrandOption = {
        label: "+ Add New",
        value: "__add_new__"
    };
    const wareHousesOptions = [
        customAddBrandOption,
        ...(Array.isArray(wareHouses) ? wareHouses : [])
    ];

    return (
        <Modal show={show} onHide={handleClose} size="md" aria-labelledby="contained-modal-title-vcenter" centered>
            <Modal.Header className={styles.Header}>
                <Heading heading={'Add Supplier'} headingStyle={styles.AddLinkHeading} />
            </Modal.Header>
            <Modal.Body className={classNames(`${theme}ModalBackground`, styles.Body)}>
                <div className={classNames(styles.AddLinkContainer)}>
                    <div className={styles.flexex}>
                        <div>
                            <div className={styles.SuggestionWrapper} ref={suggestionRef}>
                                <CustomInput
                                    label={'Supplier'}
                                    placeholder={'e.g. John'}
                                    value={values.supplier}
                                    onChange={handleSupplierChange}
                                    autoComplete="off"
                                    CustomInputStyle={classNames(`${theme}ItemBackground`, styles.CustomInputStyle)}
                                    CustomLabelStyle={styles.CustomLabelStyle}
                                    InputContainerStyle={styles.InputContainerStyle}
                                    error={errors.supplier && touched.supplier ? errors.supplier : ''}
                                />
                                {showSuggestions && supplierSuggestions.length > 0 && (
                                    <div className={styles.SuggestionsList}>
                                        {supplierSuggestions.map((supplier, index) => (
                                            <div
                                                key={index}
                                                className={styles.SuggestionItem}
                                                onClick={() => handleSelectSuggestion(supplier)}
                                            >
                                                {supplier.name}
                                            </div>
                                        ))}
                                    </div>
                                )}

                            </div>

                            <CustomInput
                                label={'Address'}
                                placeholder={'e.g. Address'}
                                value={values.address}
                                onChange={(e) => setFieldValue('address', e.target.value)}
                                CustomInputStyle={classNames(`${theme}ItemBackground`, styles.CustomInputStyle)}
                                CustomLabelStyle={styles.CustomLabelStyle}
                                InputContainerStyle={styles.InputContainerStyle}
                                error={errors.address && touched.address ? errors.address : ''}
                            />

                            <CustomInput
                                label={'Phone'}
                                placeholder={'e.g. 1234567890'}
                                value={values.phone}
                                type="number"
                                onChange={(e) => setFieldValue('phone', e.target.value)}
                                CustomInputStyle={classNames(`${theme}ItemBackground`, styles.CustomInputStyle)}
                                CustomLabelStyle={styles.CustomLabelStyle}
                                InputContainerStyle={styles.InputContainerStyle}
                                error={errors.phone && touched.phone ? errors.phone : ''}
                            />
                        </div>
                        <div>
                            <CustomInput
                                label={'Reference Number'}
                                placeholder={'e.g. Reference Number'}
                                value={values.refFeild}
                                onChange={(e) => setFieldValue('refFeild', e.target.value)}
                                CustomInputStyle={classNames(`${theme}ItemBackground`, styles.CustomInputStyle)}
                                CustomLabelStyle={styles.CustomLabelStyle}
                                InputContainerStyle={styles.InputContainerStyle}
                                error={errors.refFeild && touched.refFeild ? errors.refFeild : ''}
                            />
                            <Select
                                options={wareHousesOptions}
                                isSearchable
                                isClearable
                                value={values.whareHouse}
                                placeholder="WhareHouse"
                                menuPortalTarget={document.body}
                                styles={{ menuPortal: (base) => ({ ...base, zIndex: 9999 }) }}
                                onChange={async (item) => {
                                    if (item?.value === "__add_new__") {
                                        setshowWareModal(true);
                                        return;
                                    }
                                    setFieldValue('whareHouse', item)
                                }}
                            />
                            <div className="Error"> {errors.whareHouse && touched.whareHouse ? errors.whareHouse : ''}</div>

                        </div>
                        <WareHouse show={showWareModal} handleClose={closeProductHandler} />
                    </div>

                    <div className="d-flex justify-content-end">
                        <CustomButton text={'Cancel'} containerStyle={styles.CancelBtn} submitHandle={handleClose} />
                        <CustomButton text={'Create PO'} containerStyle={styles.SubmitBtn} submitHandle={handleSubmit} />
                    </div>
                </div>
            </Modal.Body>
        </Modal>
    );
}
